export default __webpack_public_path__ + "static/media/down_arrowgi.45444b86.gif";